// #region Imports

import * as $ from 'jquery';

// #endregion Imports

// #region Exports

export function initialize(): void {
    $('.js-accept-cookies').bind('click', acceptCookies);
}

// #endregion Exports

function acceptCookies(e) {
    e.preventDefault();
    $.get($(this).attr('href'));
    $('.cookie-notice').addClass('cookie-notice--hidden');
}